import { ResourceDetailFeature } from '@cibo/ui'
import { PLUIdTaskEditor } from './PLUIdTaskEditor'
import { RDEqipPLUId } from './types'

export const PLUIdDetailFeature: ResourceDetailFeature<RDEqipPLUId> = {
  traitId: 'eqipPLUId',
  TaskEditor: PLUIdTaskEditor,
}
